import { defineComponent as _defineComponent } from 'vue'
import { PartType } from '@/partTypes'
import store from '@/store'
import { getSawKnife } from '@/util/LayoutFuncs'
import { buryPointApi, toDecimal, verifyInputNumber } from '@/util/commonFuncs'
import {
  dealBigPlank,
  dealPlankPoly,
  getPlateKnifeDiameter,
} from '@/util/dealPaibanData'
import { calcBigpartArea } from '@/util/drawPlankFuncs'
import { message } from 'ant-design-vue'
import { computed, reactive } from 'vue'

import { isBrandBigPlank } from '../util/layoutDataDeal'
import { getPlankSizeOpration } from '../util/plankSizeOpration'


export default /*#__PURE__*/_defineComponent({
  __name: 'm-edit-size',
  props: {
    visible: { type: Boolean, default: false },
    plank: { default: null }
  },
  emits: ["update:visible", "onPaibanDataUpdate"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:visible', val: boolean): void
  (e: 'onPaibanDataUpdate', val: any[], editPlankList: any[]): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { visible: boolean, plank: any }



const isVisible = computed({
  get() {
    return props.visible
  },
  set(val) {
    emits('update:visible', val)
  },
})



const form = reactive({
  width: 0,
  height: 0,
})

const initForm = () => {
  form.width = 0
  form.height = 0
}

const editPlankList = computed(() => {
  if (props.plank) {
    const bigPart = props.plank
    const paibanData = store.state.paibanData as any[]
    return paibanData.filter(
      (plank) => plank.stockKey === bigPart.stockKey && !isBrandBigPlank(plank)
    )
  } else {
    return []
  }
})

/** 最小宽度限制 */
const minWidth = computed(() => {
  const ncSetting = store.state.ncSetting
  /** 余料摆放位置 */
  const surplusPosition = String(ncSetting.surplusPosition)

  if (!editPlankList.value.length || !editPlankList.value[0].parts.length) {
    setMinWidth(0)
    return 1
  }

  /** 修改的大板 */
  const allPlankList = editPlankList.value

  /** 下料刀直径 */
  const diameter = allPlankList[0].isUseSaw
    ? getSawKnife(ncSetting)
    : getPlateKnifeDiameter(allPlankList[0].stockKey, store.state.ncSetting)
  const minWidthList = allPlankList.map((plank) => {
    /** 修边数组（可能是四周修边的大板） */
    const marginArr = [] as string[]
    if (String(plank.margin).includes(',')) {
      marginArr.push(...String(plank.margin).split(','))
    } else {
      marginArr.push(String(plank.margin))
    }
    if (surplusPosition.includes('Left')) {
      const minX = Math.min(
        ...plank.parts
          .filter(
            (p: PartType & { blueAreaSurplus: boolean }) => !p.blueAreaSurplus
          )
          .map((p: PartType) => p.startX)
      )
      /** 大板修边 */
      const margin =
        marginArr.length > 1 ? Number(marginArr[2]) : Number(marginArr[0])
      return toDecimal(
        plank.parts.length
          ? plank.plankWidth - minX - (diameter / 2 - margin)
          : 1,
        2
      )
    } else {
      const maxX = Math.max(
        ...plank.parts
          .filter(
            (p: PartType & { blueAreaSurplus: boolean }) => !p.blueAreaSurplus
          )
          .map((p: PartType) => p.startX + p.rect.width)
      )
      /** 大板修边 */
      const margin =
        marginArr.length > 1 ? Number(marginArr[3]) : Number(marginArr[0])
      return toDecimal(
        plank.parts.length ? maxX - (diameter / 2 - margin) : 1,
        2
      )
    }
  })

  // setMinWidth(Math.max(...minWidthList))
  return Math.max(...minWidthList)
})
/** 最小高度限制 */
const minHeight = computed(() => {
  const ncSetting = store.state.ncSetting
  /** 余料摆放位置 */
  const surplusPosition = String(ncSetting.surplusPosition)
  if (!editPlankList.value.length) {
    setMinHeight(0)
    return 1
  }
  const allPlankList = editPlankList.value

  const diameter = allPlankList[0].isUseSaw
    ? getSawKnife(ncSetting)
    : getPlateKnifeDiameter(allPlankList[0].stockKey, store.state.ncSetting)

  const minHeightList = allPlankList.map((plank) => {
    /** 修边数组（可能是四周修边的大板） */
    const marginArr = [] as string[]
    if (String(plank.margin).includes(',')) {
      marginArr.push(...String(plank.margin).split(','))
    } else {
      marginArr.push(String(plank.margin))
    }

    if (surplusPosition.includes('top')) {
      const minY = Math.min(
        ...plank.parts
          .filter(
            (p: PartType & { blueAreaSurplus: boolean }) => !p.blueAreaSurplus
          )
          .map((p: PartType) => p.startY)
      )

      const margin = Number(marginArr[0])

      return toDecimal(
        plank.parts.length
          ? plank.plankHeight - minY - (diameter / 2 - margin)
          : 1,
        2
      )
    } else {
      const maxY = Math.max(
        ...plank.parts
          .filter(
            (p: PartType & { blueAreaSurplus: boolean }) => !p.blueAreaSurplus
          )
          .map((p: PartType) => p.startY + p.rect.height)
      )

      const margin =
        marginArr.length > 1 ? Number(marginArr[1]) : Number(marginArr[0])
      return toDecimal(
        plank.parts.length ? maxY - (diameter / 2 - margin) : 1,
        2
      )
    }
  })

  // setMinHeight(Math.max(...minHeightList))
  return Math.max(...minHeightList)
})

const setMinWidth = (val: number) => {
  form.width = val
}

const setMinHeight = (val: number) => {
  form.height = val
}

const handleVerifyInput = (key: 'width' | 'height') => {
  verifyInputNumber(String(form[key]), form, [key], '4-2')
}

const checkFormisValid = () => {
  const isValidate =
    form.width >= minWidth.value && form.height >= minHeight.value
  if (!isValidate) {
    message.error('修改尺寸不能小于最小值')
  }
  return isValidate
}

const handleOk = () => {
  const isValidate = checkFormisValid()
  if (!isValidate) return

  const bigPart = props.plank
  const editPlankList = store.state.paibanData.filter(
    (plank: any) =>
      plank.stockKey === bigPart.stockKey && !isBrandBigPlank(plank)
  )

  const recordDataArr: any[] = []
  editPlankList.forEach((plank: any) => {
    const recordData = getPlankSizeOpration(plank, form.width, form.height)
    recordDataArr.push(recordData)
    const changedWidth = form.width - plank.plankWidth
    const changedHeight = form.height - plank.plankHeight
    plank.parts = plank.parts.filter(
      (p: PartType & { blueAreaSurplus: boolean }) => !p.blueAreaSurplus
    )
    const surplusPosition = String(store.state.ncSetting.surplusPosition)
    if (surplusPosition.includes('Left')) {
      plank.parts.forEach((part: PartType) => {
        part.startX = part.startX + changedWidth
        dealPlankPoly(part)
      })
    }
    if (surplusPosition.includes('top')) {
      plank.parts.forEach((part: PartType) => {
        part.startY = part.startY + changedHeight
        dealPlankPoly(part)
      })
    }
    plank.plankWidth = Number(form.width)
    plank.plankHeight = Number(form.height)
    plank.path = [
      {
        x: 0,
        y: 0,
      },
      { x: plank.plankWidth, y: 0 },
      { x: plank.plankWidth, y: plank.plankHeight },
      { x: 0, y: plank.plankHeight },
      { x: 0, y: 0 },
    ]
    plank.big_plank_size = {
      width: form.width,
      height: form.height,
      otherPlate: true,
    }
    plank.hasEdited = true
    plank.bigPlank = [window.$copy(plank.path)]
    calcBigpartArea(plank, store.state.ncSetting)
    const { usedRate, usedArea } = calcBigpartArea(plank, store.state.ncSetting)
    plank.usedRate = usedRate
    plank.usedArea = usedArea
    dealBigPlank(plank)
    dealPlankPoly(plank)
  })
  buryPointApi('layout', 'edit_plank_size')
  emits('onPaibanDataUpdate', recordDataArr, editPlankList)
  initForm()
}

return { __sfc: true,props, isVisible, emits, form, initForm, editPlankList, minWidth, minHeight, setMinWidth, setMinHeight, handleVerifyInput, checkFormisValid, handleOk }
}

})